import { createSelector } from "reselect";

import { AppState, Team } from "./model";

export const routeIdSelector = (state: AppState) => {
    return state.router.params.teamId;
};

export const teamsSelector = (state: AppState) => state.teams;

export const teamSelector = createSelector(
    teamsSelector,
    routeIdSelector,
    (teams: Team[], id: string) => {
        return teams.find(t => t.id === id) || {} as Team;
    }
);

export const basePathSelector = (state: AppState) => {
    const routeName = "teams";
    return state.router.pathname.substring(0, state.router.pathname.indexOf(routeName) + routeName.length);
};
